(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/sportinfo-content-view/assets/javascripts/sportinfo-content-view.js') >= 0) return;  svs.modules.push('/components/sportinfo/sportinfo-content-view/assets/javascripts/sportinfo-content-view.js');
"use strict";


const ContentSectionTitle = svs.components.sportinfo.sportinfoContentView.ContentSectionTitle;
const config = svs.components.sportinfo.sportinfoContentView.config;
const SportinfoContentView = _ref => {
  let branding = _ref.branding,
    className = _ref.className,
    content = _ref.content,
    drawNumber = _ref.drawNumber,
    eventNumber = _ref.eventNumber,
    eventTypeId = _ref.eventTypeId,
    FallbackComp = _ref.FallbackComp,
    matchId = _ref.matchId,
    productId = _ref.productId,
    setCoupon = _ref.setCoupon,
    sportType = _ref.sportType,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'LIGHT' : _ref$theme,
    lazyComponentsMap = _ref.lazyComponentsMap,
    externalId = _ref.externalId;
  if (!content) {
    return React.createElement(FallbackComp, {
      branding: branding
    });
  }
  return content.map(contentItem => {
    const componentConfig = config[contentItem.provider](contentItem.type);
    const Component = lazyComponentsMap.get(componentConfig.component);
    const key = "".concat(contentItem.provider, "_").concat(contentItem.type);
    return React.createElement(ContentSectionTitle, {
      key: key,
      theme: theme,
      title: contentItem.title
    }, React.createElement(Component, {
      branding: branding,
      className: className,
      content: content,
      drawNumber: drawNumber,
      eventNumber: eventNumber,
      eventTypeId: eventTypeId,
      externalId: externalId,
      FallbackComp: FallbackComp,
      matchId: matchId,
      productId: productId,
      setCoupon: setCoupon,
      sportType: sportType,
      theme: theme,
      viewProps: contentItem.viewProps,
      widget: contentItem,
      widgetId: contentItem.widgetId
    }));
  });
};
setGlobal('svs.components.sportinfo.sportinfoContentView.SportinfoContentView', SportinfoContentView);

 })(window);